module.exports = __webpack_public_path__ + "static/media/DSC01840.fe42c83e.jpg";